export const Dec2022 = [
    {
        "S. NO": "1",
        "Training Name": "CCSK: Certificate of Cloud Security Knowledge (Without Certification)",
        "Session Code": "INDBANDEC2202",
        "Batch Size": "20",
        "Start Date": "5-Dec",
        "End Date": "7-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "2",
        "Training Name": "Certified Ethical Hacker V12",
        "Session Code": "INDBANDEC2201",
        "Batch Size": "15",
        "Start Date": "5-Dec",
        "End Date": "9-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "3",
        "Training Name": "AZ-900 : Microsoft Certified: Azure Fundamentals",
        "Session Code": "INDBANDEC2203",
        "Batch Size": "25",
        "Start Date": "8-Dec",
        "End Date": "9-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "4",
        "Training Name": "Payment Card Industry Data Security Standard (PCI DSS)",
        "Session Code": "INDBANDEC2204",
        "Batch Size": "15",
        "Start Date": "8-Dec",
        "End Date": "9-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "5",
        "Training Name": "CCSP : Certified Cloud Security Professional (Without Certification)",
        "Session Code": "INDBANDEC2206",
        "Batch Size": "15",
        "Start Date": "19-Dec",
        "End Date": "23-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "6",
        "Training Name": "Storytelling",
        "Session Code": "INDBANDEC2207",
        "Batch Size": "15",
        "Start Date": "19-Dec",
        "End Date": "19-Dec",
        "Practice": "",
        "Register": "Click Here"
    },
    {
        "S. NO": "7",
        "Training Name": "ISO 31000:2018 Risk Management Principles & Guidelines Implementation",
        "Session Code": "INDBANDEC2205",
        "Batch Size": "12",
        "Start Date": "22-Dec",
        "End Date": "23-Dec",
        "Practice": "",
        "Register": "Click Here"
    }
]